import * as React from 'react';

import { SeatingPreferencesProps } from '../../components/cart/seating-preference';

const SeatingPreferencesView: React.StatelessComponent<SeatingPreferencesProps> = props => {

    function onChange(preference: string) {
        if (preference != "0") {
            props.updateSeatingPreferences(preference);
        }
    }

    return (
        props.seatingPreferenceOptions.length > 0 ?
            <div className="stack-xs">
                <label htmlFor="perfquantity">{props.seatingPreferenceTitle}</label>
                <select id="perfquantity" value={props.selectedSeatingPreference} key={props.selectedSeatingPreference.length} name="" onChange={(evt) => onChange(evt.target.value)}>
                    <option value="0">{props.seatingPreferencesDefaultText}</option>
                    {
                        props.seatingPreferenceOptions.map(pref =>
                            <option key={pref} value={pref}>{pref}</option>
                        )}
                </select>
            </div>
            : null
    );
}
export default SeatingPreferencesView;


